import { createTheme } from '@mui/material/styles';

// Builds an MUI theme from a brand token file (see theme/brands/). Sized for
// a walk-up tablet kiosk: large touch targets, high-contrast text.
export function createBrandTheme(brand) {
  return createTheme({
    palette: {
      primary: { main: brand.colors.primary, contrastText: brand.colors.primaryContrast },
      secondary: { main: brand.colors.secondary, contrastText: brand.colors.secondaryContrast },
      background: { default: brand.colors.background, paper: brand.colors.background },
      text: { primary: brand.colors.text, secondary: brand.colors.textSecondary },
      success: { main: brand.colors.success },
      warning: { main: brand.colors.warning },
      error: { main: brand.colors.error },
      info: { main: brand.colors.info },
    },
    typography: {
      fontFamily: brand.fontFamily.body,
      h1: { fontFamily: brand.fontFamily.heading },
      h2: { fontFamily: brand.fontFamily.heading },
      h3: { fontFamily: brand.fontFamily.heading, fontWeight: 700 },
      h4: { fontFamily: brand.fontFamily.heading, fontWeight: 700 },
      h5: { fontFamily: brand.fontFamily.heading },
      h6: { fontFamily: brand.fontFamily.heading, fontWeight: 700 },
      fontSize: 16,
      button: { fontFamily: brand.fontFamily.heading, fontSize: '1.1rem', textTransform: 'none' },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            minHeight: 56,
            borderRadius: 12,
            padding: '12px 24px',
          },
        },
      },
    },
  });
}
